import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
  private Triangle1Mode = false;
  private Triangle2Mode = false;
  lines = [
    new Line(),
    new Line(),
    new Line({ color: 0xb06efe, isEqualSymbol: true }),
    new Line({ color: 0xb06efe, isEqualSymbol: true }),
    new Line({ color: 0xb06efe }),
    new Line({ color: 0xb06efe }),
    new Line({ color: 0x09d9c9, isDashed: true}),
    new Line({ color: 0x09d9c9, isDashed: true })
  ];
  
  constructor(private cCoord: Coord) {
    this.lines[2].setVisibleOfEqualSymbol(true);
    this.lines[3].setVisibleOfEqualSymbol(true);
    eventBus.on(EnumEventBus.Triangle1Mode, (v: boolean) => this.Triangle1Mode = v);
    eventBus.on(EnumEventBus.Triangle2Mode, (v: boolean) => this.Triangle2Mode = v);
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll())
  }

  setAllVisible = (status: boolean) => [...this.lines].forEach(l => l.visible = status);
  clearAll(){
    this.lines[2].setVisibleOfEqualSymbol(false);
    this.lines[3].setVisibleOfEqualSymbol(false);
    this.lines.forEach(l => l.clear());
  }
  draw(points: Coord[], tPoints: Coord[], interSecPoint: Coord) {
    if (this.Triangle1Mode) {
      this.lines[6].draw(points[0], points[1]);
      this.lines[0].clear();
      this.lines[1].clear();
      this.lines[7].clear();
    } else if (this.Triangle2Mode) {
      this.lines[7].draw(this.cCoord, interSecPoint);
      this.lines[0].draw(this.cCoord, points[0]);
      this.lines[1].draw(this.cCoord, points[1]);
      this.lines[6].clear();
    } else {
      this.lines[0].draw(this.cCoord, points[0]);
      this.lines[1].draw(this.cCoord, points[1]);
      this.lines[6].clear();
      this.lines[7].clear();
    }
    this.lines[2].draw(points[0], interSecPoint);
    this.lines[3].draw(points[1], interSecPoint);
    this.lines[4].draw(tPoints[0], interSecPoint);
    this.lines[5].draw(tPoints[1], interSecPoint);
  }
}